<template>
  <div ref="chart"></div>
</template>

<script>
import ApexCharts from 'apexcharts';
import { ref, onMounted, watch, onUnmounted, toRaw } from 'vue';

export default {
  name: 'ApexChart',
  props: {
    type: {
      type: String,
      default: 'line'
    },
    options: {
      type: Object,
      default: () => ({})
    },
    series: {
      type: Array,
      default: () => []
    },
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: 'auto'
    }
  },
  setup(props) {
    const chart = ref(null);
    let chartInstance = null;

    const initChart = () => {
      if (chart.value && !chartInstance) {
        // Deep clone the options to avoid Inertia serialization issues
        const chartOptions = JSON.parse(JSON.stringify(toRaw(props.options)));
        const chartSeries = JSON.parse(JSON.stringify(toRaw(props.series)));
        
        const options = {
          chart: {
            type: props.type,
            width: props.width,
            height: props.height,
            ...chartOptions.chart
          },
          series: chartSeries,
          ...chartOptions
        };
        
        chartInstance = new ApexCharts(chart.value, options);
        chartInstance.render();
      }
    };

    const updateChart = () => {
      if (chartInstance) {
        // Deep clone to avoid serialization issues
        const chartOptions = JSON.parse(JSON.stringify(toRaw(props.options)));
        const chartSeries = JSON.parse(JSON.stringify(toRaw(props.series)));
        
        chartInstance.updateOptions({
          ...chartOptions,
          series: chartSeries
        }, true, true);
      }
    };

    onMounted(() => {
      // Use nextTick to ensure DOM is ready
      setTimeout(() => {
        initChart();
      }, 100);
    });

    watch(() => [props.options, props.series], () => {
      if (chartInstance) {
        updateChart();
      }
    }, { deep: true });

    onUnmounted(() => {
      if (chartInstance) {
        chartInstance.destroy();
        chartInstance = null;
      }
    });

    return {
      chart
    };
  }
};
</script>